const actions = {
  SET_STATE: 'breadcrumbs/SET_STATE',
  GET_DATA: 'breadcrumbs/GET_DATA',
  SET_CRUMBS: 'breadcrumbs/SET_CRUMBS',
  GET_CRUMBS: 'breadcrumbs/GET_CRUMBS',
};

export default actions;
